export default "__VITE_ASSET__D51XBS0o__"